import angular from "angular";
import template from "./admin-instructor-view-time-off-request-detail.html";
import AdminInstructorsViewTimeOffRequestsViewController from "./admin-instructor-view-time-off-request-detail.controller";

function config($stateProvider, $urlRouterProvider, USER_ROLES) {
  $stateProvider.state(
    "drivecoach.admin.instructors.view.timeoffrequests.view",
    {
      url: "/:timeOffRequestId/view",
      controller: AdminInstructorsViewTimeOffRequestsViewController,
      controllerAs: "vm",
      template: template,
      data: {
        authorizedRoles: [
          USER_ROLES.admin,
          USER_ROLES.administrator,
          USER_ROLES.owner,
        ],
      },
    },
  );
}
config.$inject = ["$stateProvider", "$urlRouterProvider", "USER_ROLES"];

export default angular
  .module("admin.dashboard.instructors.view.timeoffrequests.view", [])
  .config(config)
  .controller(
    "AdminInstructorsViewTimeOffRequestsViewController",
    AdminInstructorsViewTimeOffRequestsViewController,
  );
